import script from "./PayVersion.vue?vue&type=script&setup=true&lang=js"
export * from "./PayVersion.vue?vue&type=script&setup=true&lang=js"

import "./PayVersion.vue?vue&type=style&index=0&id=4d89f764&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d89f764"]])

export default __exports__